import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { PaymentService } from '../../../../../services/payment.service';
import { HelpersService } from '../../../../../services/helpers.service';
import { AppConfig } from '../../../../../app.config';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';
import moment from 'moment';

declare var Stripe: any;

@Component({
  selector: 'app-subscription-payment',
  templateUrl: './subscription-payment.component.html',
  styleUrls: ['./subscription-payment.component.scss'],
  providers: [MessageService],
})
export class SubscriptionPaymentComponent implements OnInit {
  @Input() paymentData: any;
  @Input() countryData: any;
  @Input() currencies: any;
  @Output() close: any = new EventEmitter();

  public stripe: any;
  public card: any;
  public creatingSubscription: boolean = false;
  public paymentErrorText: string;
  public couponCode : string;
  public disableCoupons: boolean = false;

  constructor(
    private paymentService: PaymentService,
    private helpersService: HelpersService,
    private translate: TranslateService,
    private appConfig: AppConfig,
    private messageService: MessageService,
  ) {}

  ngOnInit() {

    if(this.paymentData.workshopPackage && this.paymentData.workshopPackage.pricing && this.paymentData.rentalPackage && this.paymentData.rentalPackage.pricing){
      this.disableCoupons = true;
    }

    setTimeout(() => {
      this.createStripeCard();
    }, 1000);
  }

  getPaymentTotal() {
    var total = 0;
    if (
      this.paymentData.workshopPackage &&
      this.paymentData.workshopPackage.pricing &&
      this.paymentData.workshopPackage.pricing.price
    ) {
      total += this.paymentData.workshopPackage.pricing.price;
    }
    if (
      this.paymentData.rentalPackage &&
      this.paymentData.rentalPackage.pricing &&
      this.paymentData.rentalPackage.pricing.price
    ) {
      total += this.paymentData.rentalPackage.pricing.price;
    }
    if (
      this.paymentData.whatsappPackage &&
      this.paymentData.whatsappPackage.pricing &&
      this.paymentData.whatsappPackage.pricing.price
    ) {
      total += this.paymentData.whatsappPackage.pricing.price;
    }
    return total;
  }

  getDayOfMonth() {
    return moment().format('Do');
  }

  createStripeCard() {
    this.stripe = Stripe(this.appConfig.getStripKey());

    var elements = this.stripe.elements();

    this.card = elements.create('card', {
      iconStyle: 'solid',
      style: {
        base: {
          iconColor: '#181818',
          color: '#181818',
          fontWeight: 500,
          fontFamily: 'Roboto, Open Sans, Segoe UI, sans-serif',
          fontSize: '16px',
          fontSmoothing: 'antialiased',

          ':-webkit-autofill': {
            color: '#181818',
          },
          '::placeholder': {
            color: '#777',
          },
        },
        invalid: {
          iconColor: '#d90028',
          color: '#181818',
        },
      },
    });
    setTimeout(()=>{
      this.card.mount('#card-input');
    }, 1000);    
  }

  submitPayment() {
    this.paymentErrorText = null;
    this.creatingSubscription = true;
    this.stripe.createToken(this.card).then((result) => {
      console.log(result);
      if (result.error) {
        // Inform the user if there was an error.
        this.paymentErrorText = result.error.message;
        this.creatingSubscription = false;
      } else {
        const partner = this.helpersService.getPartnerData();
        // Send the token to your server.
        this.paymentService
          .createStripeSubscription({
            ...this.paymentData,
            Coupon: this.couponCode,
            CardToken: result.token.id,
          })
          .subscribe(
            (res) => {
              if (res.error) {
                this.creatingSubscription = false;
                this.paymentErrorText = res.error;
              } else {
                this.messageService.add({
                  life: 3000,
                  detail: this.translate.instant('bikeshop.package_purchase'),
                });
                this.helpersService.savePartnerData({
                  ...partner,
                  PaymentMethod: 1,
                });
                this.close.emit();
              }
            },
            (err) => {
              this.paymentErrorText = err && err.error && err.error.err ? err.error.err : err && err.error ? err.error : JSON.stringify(err);
              this.creatingSubscription = false;
            },
          );
      }
    }),
      (err) => {};
  }
}
